module.exports = __webpack_public_path__ + "fonts/BebasNeuePro-Book.b490e7df.woff2";